/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [{
    name: 'login',
    path: '/login',
    view: 'auth/Login',
    component: import('@/views/auth/Login.vue'),
    meta: {
      layout: 'no-sidebar'
    }
  },
  {
    name: 'logout',
    path: '/logout',
    view: 'auth/Login',
    component: import('@/views/auth/Login.vue'),
    meta: {
      layout: 'no-sidebar'
    }
  },
  {
    path: '/forgot-pass',
    view: 'auth/ForgotPass',
    component: import('@/views/auth/ForgotPass.vue'),
    meta: {
      layout: 'no-sidebar'
    }
  },
  {
    path: '/create-pass',
    view: 'auth/CreatePass',
    component: import('@/views/auth/CreatePass.vue'),
    meta: {
      layout: 'no-sidebar'
    }
  },
  {
    path: '/confirm-forgot-pass',
    view: 'auth/ConfirmForgotPass',
    component: import('@/views/auth/ConfirmForgotPass.vue'),
    meta: {
      layout: 'no-sidebar'
    }
  },
  {
    name: 'Accounts',
    path: '/accounts',
    view: 'account/Index',
    component: import('@/views/account/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'account'
    }
  },
  {
    name: 'Companies',
    path: '/companies',
    view: 'company/Index',
    component: import('@/views/company/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'company'
    }
  },
  {
    name: 'Company Users',
    path: '/company_users',
    view: 'company_user/Index',
    component: import('@/views/company_user/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'company_user'
    }
  },
  {
    name: 'Company Protocols',
    path: '/company_protocols',
    view: 'company_has_protocol/Index',
    component: import('@/views/company_has_protocol/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'company_protocol'
    }
  },
  {
    path: '/dashboard',
    // Relative to /src/views
    view: 'Dashboard',
    component: import('@/views/Dashboard.vue'),
    meta: {
      layout: 'default',
      entity: 'dashboard'
    }
  },
  {
    path: '/protocol',
    name: 'Protocols',
    view: 'protocol/Index',
    component: import('@/views/protocol/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'protocol'
    }
  },
  {
    path: '/site',
    name: 'Sites',
    view: 'site/Index',
    component: import('@/views/site/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'site'
    }
  },
  {
    path: '/protocol_site',
    name: 'Protocol Sites',
    view: 'protocol_site/Index',
    component: import('@/views/protocol_site/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'protocol_site'
    }
  },
  {
    path: '/treatment',
    name: 'Treatments',
    view: 'treatment/Index',
    component: import('@/views/treatment/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'treatment'
    }
  },
  {
    path: '/external_user',
    name: 'External Users',
    view: 'external_user/Index',
    component: import('@/views/external_user/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'external_user'
    }
  },
  {
    path: '/adverse_events',
    name: 'Adverse Events',
    view: 'adverse_event/Index',
    component: import('@/views/adverse_event/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'adverse_event'
    }
  },
  {
    path: '/adverse_event',
    name: 'New Adverse Event',
    view: 'adverse_event/Upsert',
    component: import('@/views/adverse_event/Upsert.vue'),
    meta: {
      layout: 'default',
      entity: 'adverse_event'
    }
  },
  {
    path: '/adverse_event/:id',
    name: 'Adverse Event Details',
    view: 'adverse_event/Upsert',
    component: import('@/views/adverse_event/Upsert.vue'),
    meta: {
      layout: 'default',
      entity: 'adverse_event'
    }
  },
  {
    path: '/pregnancies',
    name: 'Pregnancies',
    view: 'pregnancy/Index',
    component: import('@/views/pregnancy/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'pregnancy'
    }
  },
  {
    path: '/pregnancy',
    name: 'Pregnancy',
    view: 'pregnancy/Upsert',
    component: import('@/views/pregnancy/Upsert.vue'),
    meta: {
      layout: 'default',
      entity: 'pregnancy'
    }
  },
  {
    path: '/pregnancy/:id',
    name: 'Pregnancy Details',
    view: 'pregnancy/Upsert',
    component: import('@/views/pregnancy/Upsert.vue'),
    meta: {
      layout: 'default',
      entity: 'pregnancy'
    }
  },

  {
    path: '/spms',
    name: 'SPMs',
    view: 'spm/Index',
    component: import('@/views/spm/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'spm'
    }
  },
  {
    path: '/spm',
    name: 'SPM',
    view: 'spm/Upsert',
    component: import('@/views/spm/Upsert.vue'),
    meta: {
      layout: 'default',
      entity: 'spm'
    }
  },
  {
    path: '/spm/:id',
    name: 'SPMs Details',
    view: 'spm/Upsert',
    component: import('@/views/spm/Upsert.vue'),
    meta: {
      layout: 'default',
      entity: 'spm'
    }
  },

  {
    path: '/metrics',
    name: 'Metrics',
    view: 'metrics/Index',
    component: import('@/views/metrics/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'metrics'
    }
  },
  {
    path: '/reports',
    name: 'Reports',
    view: 'reports/Index',
    component: import('@/views/reports/Index.vue'),
    meta: {
      layout: 'default',
      entity: 'reports'
    }
  }
]
